import imageUploadLogo from "../assets/img/picture-upload.svg";
import { AppRouteApi } from "../config/appRoute";

export const FileList = ({
  files,
  icon,
  underScoreCount,
  expirationTimes,
}: {
  files: string[];
  icon?: string;
  underScoreCount?: number;
  expirationTimes?: Date[];
}) => (
  <>
    {files.map((file, index) => (
      <a
        key={file}
        href={AppRouteApi.Media.ByPath(file)}
        download
        className="p-2 d-flex align-items-center text-black text-decoration-none"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={icon || imageUploadLogo}
          alt="Uploaded Item"
          className="me-2"
          height={35}
        />
        <p className="text-break">
          {!!underScoreCount
            ? file.split("_").slice(underScoreCount).join("_")
            : file}{" "}
          {!!expirationTimes && (
            <span className="text-muted">
              (Expiration Date: {expirationTimes[index]})
            </span>
          )}
        </p>
      </a>
    ))}
  </>
);
